import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@/fontawesome';

export default function GeneratingResponseBubble() {
  return (
    <div className="flex mb-4">
      <div className="flex-1 max-w-3xl">
        <div className="bg-gray-100 dark:bg-gray-700 rounded-lg px-4 py-3">
          <div className="flex items-center space-x-2 text-gray-600 dark:text-gray-400">
            <FontAwesomeIcon icon={faSpinner} className="w-4 h-4 animate-spin" />
            <span className="text-sm italic">Antwort wird generiert...</span>
          </div>
        </div>
      </div>
    </div>
  );
}